import { Box, useTheme } from '@mui/material'
import { memo, useEffect, useState } from 'react'
import Helper from '../../helpers/Helper'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'

const ResizableDivider = ({ onResize }: { onResize: (newWidth: number) => void }) => {
    const [dragging, setDragging] = useState(false)
    const theme = useTheme()

    const innerWidth = document.getElementById('editor-container')?.offsetWidth ?? 0

    const leftNavigationWidthCSS = Helper.readCSSVariable('width', '.layout-left-navigation')
    const leftNavigationWidth = parseFloat(leftNavigationWidthCSS.replace('px', '').trim())

    const paddingCSS = Helper.readCSSVariable('padding', '.layout-content-page')
    const paddingHorizontalCSS = paddingCSS.split('px')[1].trim()
    const paddingLeft = paddingHorizontalCSS ? parseFloat(paddingHorizontalCSS) : 0

    const containerWidth = innerWidth + paddingLeft + leftNavigationWidth
    const grabIconSize = 25
    const unit = parseInt(theme.spacing(1).replace('px', ''))

    useEffect(() => {
        let animationFrameId: number = null

        const handleMouseMove = (e: MouseEvent) => {
            if (dragging) {
                if (animationFrameId) cancelAnimationFrame(animationFrameId)
                animationFrameId = requestAnimationFrame(() => {
                    const newWidth = containerWidth - e.clientX + (3 * unit) + (grabIconSize)
                    if (newWidth >= 0) {
                        onResize(newWidth)
                    }
                })
            }
        }

        const handleMouseUp = () => {
            setDragging(false)
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId)
                animationFrameId = null
            }
        }

        if (dragging) {
            document.addEventListener('mousemove', handleMouseMove)
            document.addEventListener('mouseup', handleMouseUp)
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove)
            document.removeEventListener('mouseup', handleMouseUp)
            if (animationFrameId) cancelAnimationFrame(animationFrameId)
        }
    }, [dragging, onResize])

    const handleMouseDown = () => {
        setDragging(true)
    }

    return (
        <Box position='relative' width={0} height='100%'>
            <Box
                position='absolute'
                top='calc(50% - 15px)'
                right={-(grabIconSize / 2) - (unit)}
                height={grabIconSize}
                width={grabIconSize}
                display='flex'
                zIndex={99}
                justifyContent='center'
                alignItems='center'
                borderRadius={99}
                border={'solid 1px ' + theme.palette.text.secondary}
                sx={{
                    cursor: 'grab',
                    backgroundColor: theme.palette.background.paper
                }}
                onMouseDown={handleMouseDown}>
                <UnfoldMoreIcon style={{ transform: 'rotate(90deg)' }} fontSize='small' />
            </Box>
        </Box>
    )
}

export default memo(ResizableDivider)
